"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callerPath = exports.emit = exports.default = exports.log = void 0;
const EventEmitter = require("events");
const callsites = require("callsites");
const events = new EventEmitter();
const levels = ['debug', 'verbose', 'info', 'warn', 'error'];
const log = ((...args) => emit('info', args, callerPath()));
exports.log = log;
exports.default = log;
log.on = (event, handler) => (events.on(event, handler), log);
levels.forEach(level => {
    log[level] = (...args) => emit(level, args, callerPath());
});
log.events = events;
/**
 * Logging utilities can call this instead of `log` and use `callerPath`
 * to include their caller's filename instead of the utility's filename.
 */
function emit(level, args, filename) {
    if (events.listenerCount(level)) {
        events.emit(level, args, filename);
    }
    else if (defaultHandlers[level] && !events.listenerCount('all')) {
        defaultHandlers[level](...args);
    }
    events.emit('all', level, args, filename);
}
exports.emit = emit;
// The "debug" and "verbose" levels are ignored by default.
const defaultHandlers = {
    debug: null,
    verbose: null,
    info: console.log,
    warn: console.warn,
    error: console.error,
};
/**
 * Get the file name of somewhere in the call stack.
 *
 * @param depth The number of frames to skip, where zero means "the immediate caller"
 */
function callerPath(depth = 0) {
    for (const callsite of callsites()) {
        const file = callsite.getFileName();
        if (file && --depth < -2) {
            return file;
        }
    }
}
exports.callerPath = callerPath;
//# sourceMappingURL=sharedLog.js.map